import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../../base-types";

@JsonObject()
export default class OptionListValueResource {
    @JsonProperty("identifier")
    identifier: string;

    @JsonProperty("labels")
    labels: MapCultureTo<string>;

    @JsonProperty("values")
    @JsonElementType(OptionListValueResource)
    values: Array<OptionListValueResource>;
}

export { OptionListValueResource };
